"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_SWITCH_MENU_HEADER = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const EpiAppSwitchMenuItem_1 = require("../../components/EpiAppSwitchMenuItem");
const SubHeader = (0, material_1.styled)(material_1.ListSubheader)(({ theme }) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TODO: Figure out typings for themes (are themes even something we can/should share?)
    backgroundColor: theme.palette.epiAppSwitchMenuSubheader?.backgroundColor,
    margin: "-10px auto 10px",
}));
exports.APP_SWITCH_MENU_HEADER = "Select an application";
const EpiAppSwitchMenu = ({ open, close, anchorEl, applications, }) => (react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, open: open, onClose: close, keepMounted: true },
    react_1.default.createElement(SubHeader, null, exports.APP_SWITCH_MENU_HEADER),
    react_1.default.createElement("div", { "data-testid": "epi-app-switch" }, applications.map(({ id, name, meta: { link, logo } }) => (react_1.default.createElement(EpiAppSwitchMenuItem_1.EpiAppSwitchMenuItem, { key: id, logo: logo, name: name, close: close, url: link }))))));
exports.default = EpiAppSwitchMenu;
